import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import VariantList from '@app/components/manage-variant/list';

const VariantPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>Manage Variant</PageTitle>
      <VariantList />
    </>
  );
};

export default VariantPage;
